// Dedicated North Kitsap city landing pages. Each entry drives a route, its on-page copy,
// and its SEO metadata (unique title/description + LocalBusiness structured data).
export const CITIES = {
  poulsbo: {
    slug: "poulsbo",
    name: "Poulsbo",
    zip: "98370",
    lat: 47.7362,
    lng: -122.6465,
    title: "Poulsbo Handyman — Home Repairs, Installs & Maintenance | Solid Home Services",
    metaDescription:
      "Poulsbo handyman for home repairs, installs & maintenance — sheetrock, trim, mounting, shelving, caulking & more. Licensed, bonded & insured. Book a $50 estimate visit.",
    heroSub:
      "From the historic waterfront on Front Street to the homes up Finn Hill and out toward Lemolo, I help Poulsbo homeowners knock out the repairs, installs and maintenance that pile up on the honey-do list.",
    intro:
      "I'm Bryan — a one-man handyman shop right here in North Kitsap. Whether it's dustless sheetrock repair in a Liberty Bay condo, mounting a TV in a Vinland living room, or re-caulking a shower before the rainy season, Poulsbo neighbors get an honest estimate agreed before I start and a lifetime guarantee on my workmanship.",
    neighborhoods: ["downtown Poulsbo & Front Street", "Liberty Bay", "Finn Hill", "Lemolo", "Vinland", "Noll Valley"],
    landmark: "Liberty Bay",
  },
  kingston: {
    slug: "kingston",
    name: "Kingston",
    zip: "98346",
    lat: 47.7973,
    lng: -122.4968,
    title: "Kingston Handyman — Home Repairs, Installs & Maintenance | Solid Home Services",
    metaDescription:
      "Kingston handyman for home repairs, installs & maintenance — drywall, trim, mounting, shelving, leaks & caulking. Licensed, bonded & insured. Book a $50 estimate visit.",
    heroSub:
      "Kingston runs on the rhythm of the Edmonds ferry — and between the boat and the errands, home projects wait. I help Kingston homeowners from the bluffs above Appletree Cove to the lanes near Arness Park.",
    intro:
      "I'm Bryan, a North Kitsap handyman. Sheetrock patches, trim swaps, shelving, mounting, leaky faucets, fresh caulk — one booking, one guy, every trade. Kingston homeowners get an honest estimate up front and a lifetime guarantee on the work.",
    neighborhoods: ["downtown Kingston", "Appletree Cove", "Arness Park", "President Point", "Eglon"],
    landmark: "the Kingston–Edmonds ferry",
  },
  hansville: {
    slug: "hansville",
    name: "Hansville",
    zip: "98340",
    lat: 47.9187,
    lng: -122.5548,
    title: "Hansville Handyman — Home Repairs, Installs & Maintenance | Solid Home Services",
    metaDescription:
      "Hansville handyman for home repairs, installs & maintenance — sheetrock, trim, mounting, shelving, plumbing drips & caulking. Licensed, bonded & insured. Book a $50 estimate visit.",
    heroSub:
      "Out at the very top of the Kitsap Peninsula — past Point No Point and around Buck Lake — Hansville homes take the weather head-on. I keep them tight, safe and looking sharp.",
    intro:
      "I'm Bryan, a North Kitsap handyman. From Driftwood Key to Shore Woods, I handle dustless sheetrock repair, trim, mounting, shelving, plumbing drips and re-caulking for Hansville homeowners — with an honest estimate before I start and a lifetime guarantee behind every job.",
    neighborhoods: ["Point No Point", "Buck Lake", "Driftwood Key", "Shore Woods", "Norwegian Point"],
    landmark: "Point No Point Lighthouse",
  },
  "bainbridge-island": {
    slug: "bainbridge-island",
    name: "Bainbridge Island",
    zip: "98110",
    lat: 47.6262,
    lng: -122.5211,
    title: "Bainbridge Island Handyman — Home Repairs, Installs & Maintenance | Solid Home Services",
    metaDescription:
      "Bainbridge Island handyman for home repairs, installs & maintenance — drywall, trim, mounting, shelving, caulking & punch lists. Licensed, bonded & insured. Book a $50 estimate visit.",
    heroSub:
      "From Winslow's walkable core to the quiet lanes of Rolling Bay, Lynwood Center and Fort Ward, Bainbridge Island homes deserve careful hands — and I'm just a short hop away.",
    intro:
      "I'm Bryan, a North Kitsap handyman. TV and shelf mounting overlooking Eagle Harbor, sheetrock and trim repair in a Winslow bungalow, or a full pre-listing punch list — Bainbridge Island homeowners get an honest estimate agreed before I start and a lifetime guarantee on my workmanship.",
    neighborhoods: ["Winslow", "Eagle Harbor", "Lynwood Center", "Rolling Bay", "Fort Ward"],
    landmark: "the Bainbridge–Seattle ferry",
  },
  silverdale: {
    slug: "silverdale",
    name: "Silverdale",
    zip: "98383",
    lat: 47.6445,
    lng: -122.6949,
    title: "Silverdale Handyman — Home Repairs, Installs & Maintenance | Solid Home Services",
    metaDescription:
      "Silverdale handyman for home repairs, installs & maintenance — sheetrock, trim, mounting, shelving, caulking & more. Licensed, bonded & insured. Book a $50 estimate visit.",
    heroSub:
      "From the shoreline homes along Dyes Inlet and Old Town Silverdale to the neighborhoods up by Ridgetop and Island Lake, I help Silverdale homeowners clear the repairs, installs and maintenance on the list.",
    intro:
      "I'm Bryan — a one-man handyman shop based in North Kitsap, a short drive up Highway 3. Dustless sheetrock repair, TV and shelf mounting, trim swaps, re-caulking — Silverdale homeowners get an honest estimate agreed before I start and a lifetime guarantee on my workmanship.",
    neighborhoods: ["Old Town Silverdale", "Dyes Inlet", "Ridgetop", "Island Lake", "Chico", "Seabeck Highway"],
    landmark: "Dyes Inlet",
  },
  bremerton: {
    slug: "bremerton",
    name: "Bremerton",
    zip: "98310",
    lat: 47.5673,
    lng: -122.6326,
    title: "Bremerton Handyman — Home Repairs, Installs & Maintenance | Solid Home Services",
    metaDescription:
      "Bremerton handyman for home repairs, installs & maintenance — sheetrock, trim, mounting, shelving, caulking & more. Licensed, bonded & insured. Book a $50 estimate visit.",
    heroSub:
      "From the older homes in Manette and across the bridge in East Bremerton to Navy Yard City and the neighborhoods around Kitsap Lake, I help Bremerton homeowners clear the repairs, installs and maintenance on the list.",
    intro:
      "I'm Bryan — a one-man handyman shop based in North Kitsap, a straight shot down Highway 3. Dustless sheetrock repair, TV and shelf mounting, trim swaps, re-caulking — Bremerton homeowners get an honest estimate agreed before I start and a lifetime guarantee on my workmanship.",
    neighborhoods: ["Manette", "East Bremerton", "Navy Yard City", "Kitsap Lake", "Rocky Point", "Charleston"],
    landmark: "the Manette Bridge",
  },
  suquamish: {
    slug: "suquamish",
    name: "Suquamish",
    zip: "98392",
    lat: 47.731,
    lng: -122.5524,
    title: "Suquamish Handyman — Home Repairs, Installs & Maintenance | Solid Home Services",
    metaDescription:
      "Suquamish handyman for home repairs, installs & maintenance — sheetrock, trim, mounting, shelving, caulking & more. Licensed, bonded & insured. Book a $50 estimate visit.",
    heroSub:
      "From the waterfront homes along Agate Passage to the neighborhoods around Miller Bay and Port Madison, I help Suquamish homeowners clear the repairs, installs and maintenance on the list.",
    intro:
      "I'm Bryan — a one-man handyman shop right here in North Kitsap, just up the road from Suquamish. Dustless sheetrock repair, TV and shelf mounting, trim swaps, re-caulking — Suquamish homeowners get an honest estimate agreed before I start and a lifetime guarantee on my workmanship.",
    neighborhoods: ["downtown Suquamish", "Agate Passage", "Miller Bay", "Port Madison", "Indianola"],
    landmark: "the Agate Pass Bridge",
  },
};

// Order shown in nav/footer and cross-links (mirrors how the owner listed them).
export const CITY_LIST = ["poulsbo", "kingston", "bainbridge-island", "hansville", "silverdale", "bremerton", "suquamish"].map((s) => ({
  slug: s,
  name: CITIES[s].name,
}));
